

const formattedData = [
    {
        Name: 'Afghanistan',
        Water: '27.58895624',
        Food: '22.5',
        Poverty: '49.4',
        Education: '53.75999832',
        Electricity: '97.69999695',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2020',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Albania',
        Water: '70.67453739',
        Food: '7.7',
        Poverty: '46.2',
        Education: '25.82',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2019',
        ElectricityYear: '2020'
    },
    {
        Name: 'Algeria',
        Water: '72.3814561',
        Food: '6.2',
        Poverty: 'Data Not Available',
        Education: '20.95',
        Electricity: '99.80413055',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2017',
        ElectricityYear: '2020'
    },
    {
        Name: 'American Samoa',
        Water: '98.36197279',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: 'Data Not Available',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Andorra',
        Water: '90.64000336',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Angola',
        Water: 'Data Not Available',
        Food: '30.4',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '46.89060974',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Antarctica',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: 'Data Not Available',
        WaterYear: 'Data Not Available',
        FoodYear: 'Data Not Available',
        PovertyYear: 'Data Not Available',
        EducationYear: 'Data Not Available',
        ElectricityYear: 'Data Not Available',
    },
    {
        Name: 'Fr. S. Antarctic Lands',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: 'Data Not Available',
        WaterYear: 'Data Not Available',
        FoodYear: 'Data Not Available',
        PovertyYear: 'Data Not Available',
        EducationYear: 'Data Not Available',
        ElectricityYear: 'Data Not Available',
    },
    {
        Name: 'Falkland Is.',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: 'Data Not Available',
        WaterYear: 'Data Not Available',
        FoodYear: 'Data Not Available',
        PovertyYear: 'Data Not Available',
        EducationYear: 'Data Not Available',
        ElectricityYear: 'Data Not Available',
    },
    {
        Name: 'Taiwan',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: 'Data Not Available',
        WaterYear: 'Data Not Available',
        FoodYear: 'Data Not Available',
        PovertyYear: 'Data Not Available',
        EducationYear: 'Data Not Available',
        ElectricityYear: 'Data Not Available',
    },
    {
        Name: 'Palestine',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: 'Data Not Available',
        WaterYear: 'Data Not Available',
        FoodYear: 'Data Not Available',
        PovertyYear: 'Data Not Available',
        EducationYear: 'Data Not Available',
        ElectricityYear: 'Data Not Available',
    },
    {
        Name: 'W. Sahara',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: 'Data Not Available',
        WaterYear: 'Data Not Available',
        FoodYear: 'Data Not Available',
        PovertyYear: 'Data Not Available',
        EducationYear: 'Data Not Available',
        ElectricityYear: 'Data Not Available',
    },
    {
        Name: 'Antigua and Barbuda',
        Water: 'Data Not Available',
        Food: '7.1',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Argentina',
        Water: 'Data Not Available',
        Food: '13',
        Poverty: 'Data Not Available',
        Education: '22.32999992',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Armenia',
        Water: '86.91066001',
        Food: '1',
        Poverty: '19.1',
        Education: '26.07999992',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2020',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Aruba',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Australia',
        Water: 'Data Not Available',
        Food: '3.6',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Austria',
        Water: '98.900642',
        Food: '1.3',
        Poverty: '16.9',
        Education: '11.42000008',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Azerbaijan',
        Water: '88.32276401',
        Food: '0',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Bahamas',
        Water: 'Data Not Available',
        Food: '3.4',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Bahrain',
        Water: '98.98326213',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Bangladesh',
        Water: '58.51187913',
        Food: '10.7',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '96.19999695',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Barbados',
        Water: 'Data Not Available',
        Food: '7.4',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Belarus',
        Water: '94.61114668',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: '9.180000305',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Belgium',
        Water: '99.91380843',
        Food: '1.3',
        Poverty: '19.5',
        Education: '9.210000038',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Belize',
        Water: 'Data Not Available',
        Food: '6',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '97.11333466',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Benin',
        Water: 'Data Not Available',
        Food: '13.8',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '41.41095734',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Bermuda',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Bhutan',
        Water: '36.64769794',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: '11.97000027',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Bolivia',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: '13.69999981',
        Electricity: '97.55412292',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Bosnia and Herz.',
        Water: '88.86918054',
        Food: '2.8',
        Poverty: 'Data Not Available',
        Education: '21.80999947',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Botswana',
        Water: 'Data Not Available',
        Food: '25.4',
        Poverty: 'Data Not Available',
        Education: '37.13999939',
        Electricity: '71.99475861',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Brazil',
        Water: '85.76566655',
        Food: '7.3',
        Poverty: 'Data Not Available',
        Education: '25.98999977',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'British Virgin Islands',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Brunei',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: '21.43000031',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Bulgaria',
        Water: '97.61733619',
        Food: '2.9',
        Poverty: '32.5',
        Education: '14.43999958',
        Electricity: '99.69999695',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Burkina Faso',
        Water: 'Data Not Available',
        Food: '18.5',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '18.95723915',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Burundi',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: '11.17000008',
        Electricity: '11.73555565',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Cabo Verde',
        Water: 'Data Not Available',
        Food: '6.4',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '94.16174316',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Cambodia',
        Water: '27.75824113',
        Food: '15.1',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '86.40000153',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Cameroon',
        Water: 'Data Not Available',
        Food: '26.7',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '64.72136688',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Canada',
        Water: '99.03894727',
        Food: '1',
        Poverty: 'Data Not Available',
        Education: '17.93000031',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Cayman Islands',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Central African Rep.',
        Water: '6.183318229',
        Food: '61.8',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '15.46508408',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Chad',
        Water: '5.591479791',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '11.08011723',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Channel Islands',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Chile',
        Water: '98.77136473',
        Food: '3.8',
        Poverty: 'Data Not Available',
        Education: '20.52000046',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'China',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Colombia',
        Water: '73.00935643',
        Food: 'Data Not Available',
        Poverty: '17.5',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Comoros',
        Water: 'Data Not Available',
        Food: '27.4',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '86.73713684',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Dem. Rep. Congo',
        Water: '18.98772879',
        Food: '39.2',
        Poverty: 'Data Not Available',
        Education: '31.37',
        Electricity: '19.10000038',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Congo',
        Water: '45.89689647',
        Food: '55.5',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '49.51710129',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Costa Rica',
        Water: '80.51604686',
        Food: '2.8',
        Poverty: '20.71560109',
        Education: '19.95000076',
        Electricity: '99.90000153',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: "Ivory Coast",
        Water: '35.20478351',
        Food: '9.4',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '69.67912292',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Croatia',
        Water: 'Data Not Available',
        Food: '1.6',
        Poverty: '23.3',
        Education: '12.23999977',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Cuba',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Curacao',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: '17.45999908',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Cyprus',
        Water: '99.76517318',
        Food: 'Data Not Available',
        Poverty: '22.3',
        Education: '14.35999966',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Czechia',
        Water: '97.88247054',
        Food: '1.6',
        Poverty: '12.5',
        Education: '6.679999828',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Denmark',
        Water: '96.73072499',
        Food: '1.4',
        Poverty: '16.5',
        Education: '7.440000057',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Djibouti',
        Water: 'Data Not Available',
        Food: '16.5',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '61.76708221',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Dominica',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Dominican Rep',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: '16.4',
        Education: '37.70000076',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Ecuador',
        Water: '66.8266645',
        Food: '12.8',
        Poverty: '38.13',
        Education: 'Data Not Available',
        Electricity: '98.84999847',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Egypt',
        Water: 'Data Not Available',
        Food: '7.1',
        Poverty: 'Data Not Available',
        Education: '30.19000053',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'El Salvador',
        Water: 'Data Not Available',
        Food: '14.7',
        Poverty: '32',
        Education: '25.17000008',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Eq. Guinea',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '66.74772644',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Eritrea',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '52.1710968',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Estonia',
        Water: '95.76106635',
        Food: '0.8',
        Poverty: '24.3',
        Education: '8.840000153',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'eSwatini',
        Water: 'Data Not Available',
        Food: '18.3',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '79.73049927',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Ethiopia',
        Water: '12.57741919',
        Food: '19.6',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '51.0939827',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Faroe Islands',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Fiji',
        Water: 'Data Not Available',
        Food: '4.2',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Finland',
        Water: '99.63792833',
        Food: '2.4',
        Poverty: '15.6',
        Education: '9.25',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'France',
        Water: '99.24882645',
        Food: '1',
        Poverty: '17.9',
        Education: '12.69999981',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'French Polynesia',
        Water: '83.85879282',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Gabon',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '91.57156372',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Gambia',
        Water: '44.71526912',
        Food: '27.1',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '62.27306747',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Georgia',
        Water: '66.35490242',
        Food: '9.5',
        Poverty: 'Data Not Available',
        Education: '24.90999985',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Germany',
        Water: '99.99302783',
        Food: '1.1',
        Poverty: '17.4',
        Education: '7.420000076',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Ghana',
        Water: '41.4104497',
        Food: '5.6',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '85.87355042',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Gibraltar',
        Water: '100',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Greece',
        Water: '100.0000023',
        Food: '1.6',
        Poverty: '30',
        Education: '13.52999973',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Greenland',
        Water: '96.7398996',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Grenada',
        Water: 'Data Not Available',
        Food: '7.5',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '93.58644867',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Guam',
        Water: '99.43870743',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Guatemala',
        Water: '55.83407651',
        Food: '20.7',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '97.05526733',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Guinea',
        Water: 'Data Not Available',
        Food: '48.9',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '44.66867828',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Guinea-Bissau',
        Water: '24.3268252',
        Food: '29.2',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '33.33546829',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Guyana',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '92.5405426',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Haiti',
        Water: 'Data Not Available',
        Food: '45.2',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '46.92553329',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Honduras',
        Water: 'Data Not Available',
        Food: '17.9',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '93.20671082',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Hungary',
        Water: '92.58851023',
        Food: '2.1',
        Poverty: '18.9',
        Education: '11.71000004',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Iceland',
        Water: '99.99999721',
        Food: '1.3',
        Poverty: 'Data Not Available',
        Education: '6.03000021',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'India',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '99',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Indonesia',
        Water: 'Data Not Available',
        Food: '0.7',
        Poverty: 'Data Not Available',
        Education: '21.79999924',
        Electricity: '96.94999695',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Iran',
        Water: '93.98386362',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: '29.39999962',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Iraq',
        Water: '59.66446001',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Ireland',
        Water: '97.32902931',
        Food: '3.2',
        Poverty: '20.6',
        Education: '12.02000046',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Isle of Man',
        Water: '97.20756495',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Israel',
        Water: '99.32107052',
        Food: '2',
        Poverty: 'Data Not Available',
        Education: '17.26000023',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Italy',
        Water: '95.82368779',
        Food: '1.9',
        Poverty: '25.6',
        Education: '18.93000031',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Jamaica',
        Water: 'Data Not Available',
        Food: '23.1',
        Poverty: 'Data Not Available',
        Education: '29.65999985',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Japan',
        Water: '98.56544671',
        Food: '0.9',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Jordan',
        Water: '85.70051235',
        Food: '17',
        Poverty: 'Data Not Available',
        Education: '35.38000107',
        Electricity: '99.90000153',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Kazakhstan',
        Water: '89.33464774',
        Food: '0',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Kenya',
        Water: 'Data Not Available',
        Food: '26.1',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '71.4379425',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Kiribati',
        Water: '14.68780908',
        Food: '8',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '91.96302795',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'North Korea',
        Water: '66.38089515',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '52.31354523',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'South Korea',
        Water: '99.19081966',
        Food: '0.7',
        Poverty: 'Data Not Available',
        Education: '13.31000042',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Kosovo',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: '33.47999954',
        Electricity: 'Data Not Available',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Kuwait',
        Water: '100',
        Food: '4.9',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Kyrgyzstan',
        Water: '70.08973028',
        Food: '1',
        Poverty: 'Data Not Available',
        Education: '18.06999969',
        Electricity: '99.98104858',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Laos',
        Water: '17.68190469',
        Food: '8.3',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Latvia',
        Water: '96.28940218',
        Food: '0.7',
        Poverty: '27.3',
        Education: '7.059999943',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Lebanon',
        Water: '47.7',
        Food: '10.2',
        Poverty: 'Data Not Available',
        Education: '23.5200004577637',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2019',
        ElectricityYear: '2020'
    },
    {
        Name: 'Lesotho',
        Water: '28.90641412',
        Food: '30.9',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '47.35273743',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Liberia',
        Water: 'Data Not Available',
        Food: '37.3',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '27.53470993',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Libya',
        Water: 'Data Not Available',
        Food: '20.7',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '69.70735168',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Liechtenstein',
        Water: '100',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Lithuania',
        Water: '94.92379005',
        Food: '1.9',
        Poverty: '26.3',
        Education: '10.76000023',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Luxembourg',
        Water: '99.4590922',
        Food: '0.7',
        Poverty: '20.6',
        Education: '6.550000191',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Madagascar',
        Water: '20.53937743',
        Food: '10.3',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '33.7350769',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Malawi',
        Water: 'Data Not Available',
        Food: '51',
        Poverty: 'Data Not Available',
        Education: '19.40999985',
        Electricity: '14.86676884',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Malaysia',
        Water: '93.81821662',
        Food: '6.3',
        Poverty: 'Data Not Available',
        Education: '13.63000011',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Maldives',
        Water: 'Data Not Available',
        Food: '2.2',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Mali',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: '30.86000061',
        Electricity: '50.56141663',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Malta',
        Water: '100.0000004',
        Food: '1.4',
        Poverty: '20.1',
        Education: '9.300000191',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Marshall Islands',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '99.16060638',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Mauritania',
        Water: 'Data Not Available',
        Food: '7.2',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '47.34841919',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Mauritius',
        Water: 'Data Not Available',
        Food: '9.1',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '99.66165161',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Mexico',
        Water: '43.02628491',
        Food: '3.7',
        Poverty: 'Data Not Available',
        Education: '20.38999939',
        Electricity: '99.40000153',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Moldova',
        Water: '74.07106737',
        Food: '4.9',
        Poverty: 'Data Not Available',
        Education: '15.59000015',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Monaco',
        Water: '100',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Mongolia',
        Water: '30.06084561',
        Food: '5',
        Poverty: 'Data Not Available',
        Education: '18.5',
        Electricity: '98.09999847',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Montenegro',
        Water: '85.07220311',
        Food: '3.4',
        Poverty: '30.5',
        Education: '21.09000015',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Morocco',
        Water: '79.94957617',
        Food: '9.7',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Mozambique',
        Water: 'Data Not Available',
        Food: '40.4',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '30.60383224',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Myanmar',
        Water: '58.83109202',
        Food: '3.7',
        Poverty: 'Data Not Available',
        Education: '15.02000046',
        Electricity: '70.39719391',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Namibia',
        Water: 'Data Not Available',
        Food: '32.6',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '56.2586937',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Nauru',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Nepal',
        Water: '17.57565999',
        Food: '13.6',
        Poverty: '17.4',
        Education: 'Data Not Available',
        Electricity: '89.90000153',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Netherlands',
        Water: '99.97241977',
        Food: '1.4',
        Poverty: '16.5',
        Education: '4.519999981',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'New Caledonia',
        Water: '96.63820033',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: '33.02000046',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'New Zealand',
        Water: '100.0000013',
        Food: '3.5',
        Poverty: 'Data Not Available',
        Education: '12.93999958',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Nicaragua',
        Water: '55.51591693',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '88.90737915',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Niger',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '19.25190926',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Nigeria',
        Water: '21.66928927',
        Food: '19.1',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '55.40000153',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Macedonia',
        Water: '76.83340587',
        Food: '6',
        Poverty: '39.9',
        Education: '19.80999947',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Northern Mariana Islands',
        Water: '90.5262069',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Norway',
        Water: '98.64284115',
        Food: '1',
        Poverty: '16.1',
        Education: '4.900000095',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Oman',
        Water: '90.55715729',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Pakistan',
        Water: '35.83886904',
        Food: '8.7',
        Poverty: '38.8',
        Education: '34.560001373291',
        Electricity: '75.37969208',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2014',
        EducationYear: '2021',
        ElectricityYear: '2020'
    },
    {
        Name: 'Palau',
        Water: '91.31174637',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Panama',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: '18.73999977',
        Electricity: '96.70463562',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Papua New Guinea',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '60.40000153',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Paraguay',
        Water: '64.08421825',
        Food: '5.6',
        Poverty: '26.75',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Peru',
        Water: '51.26412978',
        Food: '20.5',
        Poverty: 'Data Not Available',
        Education: '25.68000031',
        Electricity: '99.31181335',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Philippines',
        Water: '47.46476694',
        Food: '4.8',
        Poverty: 'Data Not Available',
        Education: '24.09000015',
        Electricity: '96.84238434',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Poland',
        Water: '98.32523453',
        Food: '0.9',
        Poverty: '18.2',
        Education: '8.630000114',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Portugal',
        Water: '95.35370664',
        Food: '3.2',
        Poverty: 'Data Not Available',
        Education: '9.06000042',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Puerto Rico',
        Water: '99.86333333',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Qatar',
        Water: '96.18278647',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Romania',
        Water: '81.98883112',
        Food: '3.7',
        Poverty: '31.2',
        Education: '14.75',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Russia',
        Water: '76.10420617',
        Food: '0',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Rwanda',
        Water: '12.10284907',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: '26.13999939',
        Electricity: '46.59999847',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Samoa',
        Water: '46.22855352',
        Food: '3.4',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'San Marino',
        Water: '100',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Sao Tome and Principe',
        Water: '36.16896361',
        Food: '14.1',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '76.55908966',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Saudi Arabia',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: '22.30999947',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Senegal',
        Water: 'Data Not Available',
        Food: '11.2',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '70.36894226',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Serbia',
        Water: '75.03841651',
        Food: '3.8',
        Poverty: '31.7',
        Education: '16.18000031',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Seychelles',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: '26.01000023',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Sierra Leone',
        Water: '10.62058316',
        Food: '31.5',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '26.20088577',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Singapore',
        Water: '100',
        Food: '0.7',
        Poverty: 'Data Not Available',
        Education: '4.460000038',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Sint Maarten (Dutch part)',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Slovak Republic',
        Water: '99.23773585',
        Food: '1.6',
        Poverty: '16.4',
        Education: '10.75',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Slovenia',
        Water: '98.27432091',
        Food: '0.6',
        Poverty: '14.4',
        Education: '7.679999828',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Solomon Islands',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '73.34648132',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Somalia',
        Water: 'Data Not Available',
        Food: '41.6',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '49.73086929',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'South Africa',
        Water: 'Data Not Available',
        Food: '8',
        Poverty: 'Data Not Available',
        Education: '29.87999916',
        Electricity: '84.38553619',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'S. Sudan',
        Water: 'Data Not Available',
        Food: '62.3',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '7.241338253',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Spain',
        Water: '99.58733342',
        Food: '2',
        Poverty: '25.3',
        Education: '13.88000011',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Sri Lanka',
        Water: 'Data Not Available',
        Food: '1.1',
        Poverty: '16',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'St. Kitts and Nevis',
        Water: 'Data Not Available',
        Food: '6.4',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'St. Lucia',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: '35.40999985',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'St. Martin (French part)',
        Water: '96.69929543',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'St. Vincent and the Grenadines',
        Water: 'Data Not Available',
        Food: '10.3',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Sudan',
        Water: 'Data Not Available',
        Food: '17.4',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '55.38970184',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Suriname',
        Water: '55.76043424',
        Food: '7.2',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '98.20477295',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Sweden',
        Water: '99.75180105',
        Food: '1.3',
        Poverty: '18.8',
        Education: '6.460000038',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Switzerland',
        Water: '94.24815385',
        Food: '0',
        Poverty: 'Data Not Available',
        Education: '8.619999886',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Syria',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '89.14031982',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Tajikistan',
        Water: '55.23686279',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '99.77929688',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Tanzania',
        Water: 'Data Not Available',
        Food: '25.8',
        Poverty: 'Data Not Available',
        Education: '14.35000038',
        Electricity: '39.90000153',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Thailand',
        Water: 'Data Not Available',
        Food: '10.5',
        Poverty: 'Data Not Available',
        Education: '15.13000011',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Timor-Leste',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '96.1233139',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Togo',
        Water: '19.56098104',
        Food: '18.8',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '53.99743271',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Tonga',
        Water: '29.50420143',
        Food: '6',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Trinidad and Tobago',
        Water: 'Data Not Available',
        Food: '10.2',
        Poverty: 'Data Not Available',
        Education: '17.05999947',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Tunisia',
        Water: '79.28615477',
        Food: '12.6',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Turkey',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: '39.8',
        Education: '28.31999969',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Turkmenistan',
        Water: '94.83423327',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Turks and Caicos Islands',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '99.40000153',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Tuvalu',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '99.68923187',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Uganda',
        Water: '16.64790598',
        Food: '23.2',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '42.07441711',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Ukraine',
        Water: '89.02047539',
        Food: '3.2',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'United Arab Emirates',
        Water: 'Data Not Available',
        Food: '0.8',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'United Kingdom',
        Water: '99.82247708',
        Food: '1.1',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'United States of America',
        Water: '97.32571774',
        Food: '0.7',
        Poverty: 'Data Not Available',
        Education: '13.89000034',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Uruguay',
        Water: 'Data Not Available',
        Food: '7.3',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Uzbekistan',
        Water: '58.83006461',
        Food: '5.6',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Vanuatu',
        Water: 'Data Not Available',
        Food: '2.4',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '67.33326721',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Venezuela',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Vietnam',
        Water: 'Data Not Available',
        Food: '0.6',
        Poverty: 'Data Not Available',
        Education: '14.18000031',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Virgin Islands (U.S.)',
        Water: '97.93599355',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'West Bank and Gaza',
        Water: '79.69894195',
        Food: '3.5',
        Poverty: 'Data Not Available',
        Education: '33.65000153',
        Electricity: '100',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Yemen',
        Water: 'Data Not Available',
        Food: 'Data Not Available',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '73.75792694',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Zambia',
        Water: 'Data Not Available',
        Food: '32.6',
        Poverty: 'Data Not Available',
        Education: '31.04999924',
        Electricity: '44.5244751',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'Zimbabwe',
        Water: '29.53588969',
        Food: '31.3',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '52.74766922',
        WaterYear: '2020',
        FoodYear: '2020',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    },
    {
        Name: 'World Average',
        Water: '74.2660341703122',
        Food: '10.5',
        Poverty: 'Data Not Available',
        Education: 'Data Not Available',
        Electricity: '90.435576612831',
        WaterYear: '2020',
        FoodYear: '2019',
        PovertyYear: '2019',
        EducationYear: '2020',
        ElectricityYear: '2020'
    }
    
]

export default formattedData;